// extracted by mini-css-extract-plugin
export default {"customSelect":"Custom_customSelect__Vh9Nx","customOption":"Custom_customOption__wbe3Q"};